import React, { PureComponent } from 'react';
import './WidgetMapaAramet.css';
import PropTypes from 'prop-types';
import { translate } from '../../utils/translations';
import Header from '../../partials/Header/Header';
import logo from '../../img/logo.png';
import Nav from '../../partials/Nav/Nav';
//import ArametNav from '../../partials/ArametNav/ArametNav';
import { ArametPrediction } from '../../partials/ArametPrediction/ArametPrediction';
//import { debounce } from '../../utils/utils';
import { WIDGET_MARGIN_BOTTOM } from '../../utils/globals';
import ArametLegend from '../../partials/ArametLegend';
import { Fragment } from 'react/cjs/react-jsx-runtime.production.min';
import {
    formatDateByType,
} from '../../utils/utils';



const WIDGET_CONTENT_MARGIN_BOTTOM = { preview: 70, iframe: 128 };


export class WidgetMapaAramet extends PureComponent {

    state = {
        day: 0,
        topoJsonNav: {
            0: true,
            1: false,            
        },
        selectedNavItem: 0,
        windowWidth : 0,   
        zoom: 0, 
    };
   
    static propTypes = {
        config: PropTypes.shape({
            language: PropTypes.string,
            target: PropTypes.string,
            color: PropTypes.string,
        }),
        dataAramet: PropTypes.object,  
        preview: PropTypes.bool,
        widgetDate: PropTypes.string,
        widgetTime: PropTypes.string,
    };
   
    render() {

        const { topoJsonNav, zoom, selectedNavItem, windowWidth } = this.state;
        const { preview, config, widgetDate, dataAramet, widgetTime } = this.props;
        const { color, language, target } = config;
        
       
        return (
            <div
                className="WidgetMapaAramet mc-widget"
                style={{
                    width: !preview ? '100%' : null,
                    height: !preview
                        ? `calc(100% - ${WIDGET_MARGIN_BOTTOM}px)`
                        : null,
                }}
            >
                <Header color={color} logo={logo} target={target} />


                <div
                    className="mc-widget-wrapper"
                    style={{ height: 'calc(100% - 38px)' }}
                >
                    <Nav
                        alternativeTitle={translate(
                            language,
                            'aramet_title'
                        )}
                        language={language}
                        widgetDate={dataAramet.dataSortida != null ? formatDateByType(dataAramet.dataSortida, 'date') : widgetDate}
                        hour={dataAramet.dataSortida != null ? formatDateByType(dataAramet.dataSortida, 'time') : widgetTime}
                        target={target}
                    />

                    
                    <div
                        className={'mc-widget-content one-map'}
                        style={{
                            height: preview
                                ? `calc(100% - ${
                                        WIDGET_CONTENT_MARGIN_BOTTOM.preview
                                    }px)`
                                : `calc(100vh - ${
                                        WIDGET_CONTENT_MARGIN_BOTTOM.iframe
                                    }px)`                            
                        }}
                    >
                        {/*<div>
                            <ArametNav  
                                color={color}               
                                topoJsonNav={topoJsonNav}                
                                language={language}             
                                onNavItemSelect = {this.handleNavItemSelected}
                                selectedNavItem={selectedNavItem}
                            />
                        </div>*/}
                    
                    
                        {Object.keys(dataAramet).length === 0 || !dataAramet.cataleg || dataAramet.dataSortida === null ? (
                            <p>{translate(language, 'no_data')}</p>
                        ) : (    
                            <Fragment>                      
                                <div className="aramet-map-wapper">                                    
                                    {dataAramet && (
                                        <ArametPrediction
                                            mapId="map-aramet"                                                    
                                            dataAramet={dataAramet}
                                            selectedNavItem = {selectedNavItem}
                                            color={color}                                                                                            
                                            setParentZoomState={
                                                this.setZoom
                                            }
                                            zoom={zoom}   
                                            onNavItemSelect = {this.handleNavItemSelected}
                                            topoJsonNav={topoJsonNav}                
                                            language={language}
                                        />
                                    )}
                                </div>                                 
                                <ArametLegend 
                                    selectedNavItem={selectedNavItem}
                                    language={language}  
                                    windowWidth={windowWidth}
                                    dataAramet={dataAramet}
                                />  
                            </Fragment>                                                       
                        )}            
                        
                    </div>
                </div>
            </div>
        );
    }

    componentDidMount() {

        let div = document.querySelector('.WidgetMapaAramet');
        
        this.setWindowWidth(div.offsetWidth);

       
        /*
        window.addEventListener('resize', () => {
            this.flexBehaviour();
        });
        */
    }

    componentWillUnmount() {
        //window.removeEventListener('resize', this.handler);
    }

    componentDidUpdate() {
        //this.flexBehaviour();        
    }

    setWindowWidth = windowWidth => {
        this.setState({ windowWidth });
    };
    

    /*
    flexBehaviour = debounce(() => {
        if (this.props.preview) return;
        const w = window.innerWidth;
        const h = window.innerHeight;

        const proportionalWidth = w / h;
        const proportionalHeight = h / w;

        const widthThreshold = 1.4;
        const heightThreshold = 2.2;
       
        let timeOfDay = 'both';

        

        this.setState({ timeOfDay });
    });
    */

    setZoom = zoom => this.setState({ zoom });

    handleNavItemSelected = selectedItem => {
        this.setState({ selectedNavItem: selectedItem })
    }
}



// WEBPACK FOOTER //
// ./src/widgets/MapaAramet/WidgetMapaAramet.js